export default __webpack_public_path__ + "static/media/teamwork.46f713e0.png";